import React from "react";
import TextAreaInput from "../inputs/TextAreaInput";
import Modal from '../Modal'


class ReportModal extends React.Component {
    state = {

        report: [
            { title: "I just don't like it" },
            { title: "It's spam" },
            { title: "Sexual Activity" },
            { title: "Hate speech or symblos" },
            { title: "Bulling or harassment" },
            { title: "False information" },
            { title: "Scam or Fraud" },
        ]

    }


    render() {
        let options = this.state.options
        return (

            <Modal maxWidth={350} height={"100%"} ref={el => this.modal = el}>
                <div className="w-100 br-10 p-4" style={{ backgroundColor: "white" }} >
                    <p>Why are you reporting?</p>
                    <div className="w-100 mt-4">
                        {this.state.report.map((prop, index) => {
                            return (
                                <button className="flexcb w-100 border-hover py-1">
                                    <p>{prop.title}</p>
                                    <img src="/assets/icons/chevron.right.svg" />
                                </button>
                            )
                        })}
                    </div>
                    <div className="mt-4">
                        <p>Or you can tell us the report!</p>
                        <div className=" mt-2">
                            <TextAreaInput changeValue={this.changeDescription} data={this.state.permission?.description} header={{ key: 'description', information: { rows: 3, placeholder: '{{lang}}description', } }} />
                        </div>
                        <div className="w-100 d-flex mt-2" style={{justifyContent:"flex-end"}}>
                            <button className="px-3 py-2 br-10" style={{backgroundColor:"red",}}>
                                <p className="white font-size-14 weight-500">Submit</p>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );

    }
}


export default ReportModal;
